const en = {
  // Home
  'home.companyName': 'OUR ENGINEERING',
  'home.support': 'SUPPORT',
  'home.privacy': 'PRIVACY POLICY',
  'home.term': 'TERM',

  // Support
  'support.title': 'SUPPORT',
  'support.intro': 'Thank you for using services by OUR ENGINEERING.',
  'support.description': 'Founded in Japan and operated by Kosuke Osada and Senri Gotoda, we are dedicated to providing a unique and seamless experience for our users.',
  'support.contactTitle': 'Contact Information',
  'support.email': 'contact@ourengineeringstudio.com',
  'support.emailLabel': 'Email:',
  'support.responseTimeLabel': 'Response Time:',
  'support.responseTime': 'We typically respond within 24-48 hours during business days (Mon-Fri).',
  'support.urgentLabel': 'Urgent Matters:',
  'support.urgent': 'Please mark your subject line with [URGENT].',
  'support.techTitle': 'Technical Support',
  'support.techIntro': 'To help us resolve your issue quickly, please include:',
  'support.techDevice': 'Device and OS version',
  'support.techDescription': 'Description of the issue and steps to reproduce',
  'support.techScreenshots': 'Screenshots (if relevant)',

  // Privacy Policy
  'privacy.title': 'PRIVACY POLICY',
  'privacy.lastUpdated': 'Last updated: March 9, 2026',
  'privacy.intro': 'OUR ENGINEERING ("we", "our", or "us") operates mobile applications and web services. This policy informs you of our practices regarding the collection, use, and disclosure of personal data.',
  'privacy.section1Title': '1. Information Collection and Use',
  'privacy.section1Personal': 'We may collect your name and email address when you contact us.',
  'privacy.section1PersonalLabel': 'Personal Information:',
  'privacy.section1Usage': 'We may collect device information, IP address, and usage patterns to improve our services.',
  'privacy.section1UsageLabel': 'Usage Data:',
  'privacy.section2Title': '2. Compliance with Japanese Laws',
  'privacy.section2Body': 'We comply with the Act on the Protection of Personal Information (APPI) of Japan.',
  'privacy.section3Title': '3. Global Privacy Rights',
  'privacy.section3GdprLabel': 'GDPR Rights (EU Residents):',
  'privacy.section3Gdpr': 'Rights to access, rectification, erasure, and data portability.',
  'privacy.section3CcpaLabel': 'CCPA Rights (California Residents):',
  'privacy.section3Ccpa': 'Rights to know, delete, and opt-out of the sale of personal information.',
  'privacy.section4Title': '4. Data Security',
  'privacy.section4Body': 'We implement appropriate security measures, but please note that no method of transmission over the internet is 100% secure.',
  'privacy.section5Title': '5. Children\'s Privacy',
  'privacy.section5Body': 'Our services are not directed to children under 13. We do not knowingly collect personal data from children.',
  'privacy.section6Title': '6. Governing Law',
  'privacy.section6Body': 'This Privacy Policy is governed by the laws of Japan.',
  'privacy.contactTitle': 'Contact',

  // Term
  'term.title': 'TERM',
  'term.section1Title': '1. Acceptance of Terms',
  'term.section1Body': 'By accessing and using the applications and services provided by OUR ENGINEERING (collectively, the "Services"), you agree to be bound by these terms.',
  'term.section2Title': '2. Privacy Policy Reference',
  'term.section2Body': 'Your use of the Services is also governed by our Privacy Policy. Please review it carefully to understand our practices.',
  'term.section3Title': '3. User Responsibilities',
  'term.section3Body': 'You agree to use our Services responsibly and must not use them for any unlawful purpose or violate any intellectual property rights.',
  'term.section4Title': '4. Disclaimer of Warranties',
  'term.section4Body': 'Our Services are provided \'as is\' and without warranty of any kind. We do not guarantee that the Services will always be secure, error-free, or function without disruptions.',
  'term.section5Title': '5. Limitation of Liability',
  'term.section5Body': 'To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, or consequential damages, or any loss of data or profits resulting from your use of or inability to use the Services.',
  'term.section6Title': '6. Governing Law and Jurisdiction',
  'term.section6Body': 'These terms are governed by the laws of Japan. Any disputes shall be subject to the exclusive jurisdiction of the courts of Japan.',

  // Waitlist
  'waitlist.comingSoon': 'Coming Soon',
  'waitlist.emailPlaceholder': 'Enter your email',
  'waitlist.submit': 'Join Waitlist',
  'waitlist.success': "You're on the list! We'll notify you at launch.",
  'waitlist.successTitle': "You're on the list!",
  'waitlist.successBody': "We'll let you know when the app is ready. Stay tuned!",
  'waitlist.backHome': 'Back to Home',
  'waitlist.alreadyRegistered': 'This email is already registered.',
  'waitlist.error': 'Something went wrong. Please try again.',

  // Common
  'common.home': 'HOME',
};

export default en;
